import React from 'react';
import styled from 'styled-components';
import { Tooltip, theme, Icon, Text } from 'components';
import {
  AnsweringServiceType,
  AnsweringSubscriptionJsonType,
} from '@bb/domain/dist/types/AnsweringSubscription';
import { AuthContext } from 'contexts';
import { formatPhoneNumber } from 'utils';

type AnsweringTagProps = {
  subscription: AnsweringSubscriptionJsonType;
  useAppointmentDesk: boolean;
};

const AnsweringTag: React.FC<AnsweringTagProps> = ({
  subscription,
  useAppointmentDesk,
}) => {
  if (!subscription || !useAppointmentDesk) {
    return null;
  }
  return (
    <StyledContainer>
      <StyledIconContainer>
        <Icon type="antdPhoneFilled" color="info" />
      </StyledIconContainer>
      <StyledSubscriptionContainer>
        <Text strong>
          {subscription.serviceType === AnsweringServiceType.AppointmentDesk
            ? 'Appointment Desk'
            : 'Live Concierge'}
          <Tooltip
            title="Add the phone number below to your brokerage's 
          listings on the MLS, or redirect any existing showing related phone numbers to this number,
           to begin accepting showings requests for your listings over the phone."
          >
            <span>
              <Icon
                type="antdInfoCircleFilled"
                width={14}
                height={14}
                offset={[3, 1]}
              />
            </span>
          </Tooltip>
        </Text>
        <Text type="secondary">Paste This on your listings</Text>
        <Text> {formatPhoneNumber(subscription.answeringServicePhone)}</Text>
      </StyledSubscriptionContainer>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  border: 1px solid;
  border-color: ${theme.gray4};
  border-radius: 3px;
  height: fit-content;
  padding: 15px;
`;

const StyledIconContainer = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${theme.blue1};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledSubscriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export default AnsweringTag;
